import React from "react";
import SeoTable from "./components/SeoTable";

function ProductSeoTable() {
  return <SeoTable entityType="product" />;
}

export default ProductSeoTable;
